import { screens } from '@liveauctioneers/hammer-ui-theme';

import useIsWiderThan from './useIsWiderThan';

const TABLET_WIDTH = parseInt(screens.tabletMax.max);

export const useIsTabletLayout = () => {
    return !useIsWiderThan(TABLET_WIDTH);
};
